import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {  Table } from '../../common';
import { getPaymentHistory } from '../../../backend-services';
import { IPayment } from '../../../@types';
import dayjs from "dayjs";
import {formatMoney} from "../../../utils";
import {DownloadIcon} from "../../../assets/icons";
type Props = {
  reloadSignal?: number; // This prop will trigger a reload when changed
};

const PaymentHistoryTable: React.FC<Props> = ({ reloadSignal }) => {
  const [paymentHistory, setPaymentHistory] = useState<IPayment[]>([]);
  const [isLoading, setLoading] = useState(false);
  const params = useParams<{ invoiceNo: string }>();
  useEffect(() => {
    if (params && params.invoiceNo) {
      setLoading(true);
      getPaymentHistory(params.invoiceNo)
        .then((data) => {
          setPaymentHistory(data);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [params, reloadSignal]);

  const renderPaymentData = () => {
    return paymentHistory.map((payment) => ({
      date: dayjs(payment.createdAt).format('MMM DD, YYYY'),
      amount: formatMoney(payment.amount),
      method: payment.paymentType,
      proof: (
        <p className=" pl-2 py-[4px] w-[80px] rounded-[4px] ">
          <a className="flex gap-[21px]" href="#payment-proof">
            <DownloadIcon />
          </a>
        </p>
      ),
    }));
  };

  if (isLoading) {
    return <p>Loading payment history...</p>; 
    // Update this as per your loading state UI
  } else if(paymentHistory.length < 1) {
    return <p>Payment unavailable... you can simply add using the Record payment button</p>;
  }

  return (
    <>
      {paymentHistory.length > 0 && <h2 className="text-[16px] font-semibold flex justify-start items-start">Payment History</h2>}
      <Table
        isLoading={isLoading}
        head={{
          date: { title: 'Payment Date' },
          amount: { title: 'Payment Amount' },
          method: { title: 'Payment Method' },
          proof: { title: 'Proof of Payment' },
        }}
        data={renderPaymentData()}
        key={paymentHistory.length}
        payHistoryTable={true}
      />
    </>
  );
};

export default PaymentHistoryTable;
